import React from "react";
import LiveBoards from "../../components/liveboards/LiveBoards";

function LiveBoardsPage() {
  return <LiveBoards />;
}

export default LiveBoardsPage;
